declare global {
  interface Window {
    dataLayer: any;
  }
}

type GTMEvent = 'pmFormSubmission';

interface ICreateGTMEvent {
  event: GTMEvent;
  gaEvent: string;
  gaCategory: string;
  gaAction: string;
  'Page URL'?: string;
}

export const createGTMEvent = (args: ICreateGTMEvent) => {
  try {
    if (typeof window !== 'undefined' && window.dataLayer) {
      let url: string = window.location.href;
      window.dataLayer.push({
        event: args.event,
        gaEvent: args.gaEvent,
        gaCategory: args.gaCategory,
        gaAction: args.gaAction,
        'Page URL': args['Page URL'] || url,
      });
    }
  } catch (e) {
    console.error(e);
  }
};
